import Model from "../classes/Model";
import Api from "../classes/api/Client";
import User from "./User";

export default class Sms extends Model {

    static STATUS_ACCEPTED = 1;
    static STATUS_REJECT = 2;

    get id() {
        return this._id;
    }

    set clientId(value) {
        this._clientId = value;
    }
    get clientId() {
        return this._clientId;
    }
    set outerId(value) {
        this._outerId = value;
    }
    get outerId() {
        return this._outerId;
    }

    set phone(value) {
        this._phone = value;
    }
    get phone() {
        return this._phone;
    }

    set content(value) {
        this._content = value;
    }
    get content() {
        return this._content;
    }

    set status(value) {
        this._status = value;
    }
    get status() {
        return this._status;
    }


    get createdAt() {
        return this._createdAt;
    }
    set createdAt(value) {
        this._createdAt = value;
    }
    get createdBy() {
        return this._createdBy;
    }
    set createdBy(value) {
        this._createdBy = value;
    }
    set creator(value) {
        this._creator = value;
    }
    get creator() {
        return this._creator;
    }


    constructor (config) {
        super();

        for (let field in config) {
            if (config.hasOwnProperty(field) === false) {
                continue;
            }
            this[`_${field}`] = config[field];
        }
    }

    toRequest() {
        // return {
        //     client_id: this.clientId,
        // };
    }

    static toResponse(data) {

        let creator = null;
        if (undefined !== data.creator && data.creator) {
            creator = new User(User.toResponse(data.creator));
        }

        return {
            id: data.id,
            outerId: data.outer_id,
            clientId: data.client_id,
            phone: data.phone,
            content: data.content,
            status: data.status,
            createdAt: data.created_at,
            createdBy: data.created_by,
            creator: creator,
        };
    }

    static getList(clientId, page = 1, perPage = 10, sort = undefined, extraFields = []) {
        return Api.getSms(clientId, page, perPage, sort, extraFields).then((response) => {
            let data = [];
            for (let sms of response.data) {
                data.push(new this(this.toResponse(sms)));
            }
            return {data, headers: response.headers};
        });
    }

}
